// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk-" + chunkId + "-" + {"53":"c6a42ff804fa728f21ac","970":"018575125ab5ee0ee7db"}[chunkId] + ".js";
};